'use client'
import { useCallback } from 'react'
import { useDropzone } from 'react-dropzone'
import { CloudUploadIcon } from '@heroicons/react/outline'

type Props = {
	importCsv: (contactsCsv: File) => void
}

const FileUploader = ({ importCsv }: Props) => {
	const onDrop = useCallback(
		(acceptedFiles: File[]) => {
			acceptedFiles.forEach(file => {
				importCsv(file)
			})
		},
		[importCsv],
	)
	const { getRootProps, getInputProps, isDragActive } = useDropzone({
		onDrop,
		maxFiles: 1,
		multiple: false,
		accept: {
			'text/csv': ['.csv'],
		},
	})

	return (
		<div
			{...getRootProps()}
			className={`dropzone ${
				isDragActive ? 'border-green-500' : 'border-cyan-700'
			} flex flex-col max-w-5x items-center p-6 border-2 rounded-lg hover:bg-green-100 active:bg-green-200`}
		>
			<input {...getInputProps()} />
			<div className="border-2 rounded-lg p-2 w-min mb-5">
				<CloudUploadIcon height={30} width={30} />
			</div>
			<p>
				<span className="font-bold">Click to upload</span> or drag and drop
			</p>
			<p className="text-sm text-slate-400 ">Only CSV files are supported</p>
		</div>
	)
}

export default FileUploader
